import { SocialServiceOfferNoteDialogStore } from './social-service-offer-note-dialog.store';
import { fb, translate } from '../../../../../modules/shared/shared.global-service';
import { Component, effect, inject, input, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { BaseDialogComponent } from '../../../../kit/base-dialog/base-dialog.component';
import { SocialServiceProcedureTypeEnum } from '@libs/types/src/services/enum/social-service-intervention-type.enum';
import { NumberInputComponent } from '../../../../kit/input/text-input/number-input.component';
import { TagsInputComponent } from '../../../../kit/input/tags-input/tags-input.component';
import {
    ServicePatternWysiwygComponent,
} from '../../../../../modules/content/components/common/service-pattern-wysiwyg/service-pattern-wysiwyg.component';
import { ServicePatternStructureUsageEnum } from '@libs/types/src/services/enum/service-pattern-structure-usage.enum';
import { WarnFloatMessageComponent } from '../../../../kit/float-message/warn-float-message.component';

@Component({
    selector: 'app-social-service-offer-note-dialog',
    templateUrl: './social-service-offer-note-dialog.component.html',
    styleUrl: './social-service-offer-note-dialog.component.scss',
    standalone: true,
    providers: [SocialServiceOfferNoteDialogStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        NumberInputComponent,
        TagsInputComponent,
        ServicePatternWysiwygComponent,
        WarnFloatMessageComponent,
    ],
})
export class SocialServiceOfferNoteDialogComponent extends BaseDialogComponent {

    public readonly store = inject(SocialServiceOfferNoteDialogStore);

    protected readonly durationNoteInput = viewChild<NumberInputComponent>('durationNoteInput');
    protected readonly durationPreparationInput = viewChild<NumberInputComponent>('durationPreparationInput');
    protected readonly durationSelfReflectionInput = viewChild<NumberInputComponent>('durationSelfReflectionInput');
    protected readonly tagInput = viewChild<TagsInputComponent>(TagsInputComponent);

    protected readonly prefix = 'workData.individualWork.';
    protected durationCheck: string | null = null;
    protected oldDuration = 0;

    protected form = fb.group({
        durationOther: fb.control<number>(0),
        durationNote: fb.control<number>(0),
        durationPreparation: fb.control<number>(0),
        durationSelfReflection: fb.control<number>(0),
        note: fb.control<string>('', { nonNullable: true }),
        tags: fb.control<string[]>([]),
    });

    constructor() {
        super();

        this.oldDuration = (this.dialogConfig.data.durationNote || 0)
            + (this.dialogConfig.data.durationPreparation || 0)
            + (this.dialogConfig.data.durationSelfReflection || 0)
        ;
        this.form.patchValue({
            note: this.dialogConfig.data.note || '',
            tags: this.dialogConfig.data.tags || [],
            durationNote: this.dialogConfig.data.durationNote || 0,
            durationPreparation: this.dialogConfig.data.durationPreparation || 0,
            durationSelfReflection: this.dialogConfig.data.durationSelfReflection || 0,
            durationOther: this.oldDuration,
        });

        effect(() => {
            this.durationNoteInput()?.setValue(this.dialogConfig.data.durationNote || 0);
            this.durationSelfReflectionInput()?.setValue(this.dialogConfig.data.durationSelfReflection || 0);
            this.durationPreparationInput()?.setValue(this.dialogConfig.data.durationPreparation || 0);
            this.tagInput()?.setValue(this.dialogConfig.data.tags || []);
        });
    }

    public override save(): void {
        this.dialogRef.close({
            ...this.dialogConfig.data,
            ...this.form.value,
        });
    }

    protected setValue(value: any, key: string): void {
        (this.form.controls as any)[key].setValue(value);

        switch (key) {
            case 'durationNote':
            case 'durationPreparation':
            case 'durationSelfReflection':
                this.form.controls.durationOther.setValue(
                    (this.form.value.durationNote || 0)
                    + (this.form.value.durationPreparation || 0)
                    + (this.form.value.durationSelfReflection || 0),
                );
        }

        if (this.form.value.durationOther !== this.oldDuration) {
            this.durationCheck = translate.instant(
                `workData.individualWork.message.newDurationOther`,
                {
                    oldTime: this.oldDuration,
                    newTime: this.form.value.durationOther,
                });
        } else {
            this.durationCheck = null;
        }
    }

    protected queryTags(search: string): void {
        this.store.api.searchWorkOfferTags({
            search,
            limit: 100,
            serviceId: this.dialogConfig.data.serviceId,
        });
    }

    protected readonly SocialServiceProcedureTypeEnum = SocialServiceProcedureTypeEnum;
    protected readonly ServicePatternStructureUsageEnum = ServicePatternStructureUsageEnum;
}
